import style from "./style/registration.module.scss";
import {CounselorField} from "./registration/CounselorField";
import React from "react";
import {useTranslation} from "react-i18next";
import {Post} from "../../layout/content/post/Post";
import {useCounselorStore} from "./registration/hooks/counselorStore";
import {useCounselorCreator} from "./registration/hooks/useCounselorCreator";

export function CounselorRegistration() {
    /**
     * 상담사 등록 페이지
     */
    const {t} = useTranslation("counselorGroup");
    const { counselorDTO, validateCounselor } = useCounselorStore();
    const {createCounselor} = useCounselorCreator();

    const onClickCreateButton = () => {
        const isValid = validateCounselor();
        if(!isValid) return false;
        if (!counselorDTO) return false;
        const isConfirm = window.confirm('상담사를 등록하시겠습니까?');

        if (isConfirm) {
            createCounselor({
                ...counselorDTO,
                ...(counselorDTO.counselingAffiliationIdx === "independent" ? {
                    counselingAffiliationIdx: undefined
                } : {
                    counselingAffiliationIdx: counselorDTO.counselingAffiliationIdx
                })
            }).then(() => {
                alert('상담사가 등록되었습니다.')
                window.location.href = "/counselor/manager"
            });
        }
    }

    return (
        <>
            <div className={style.postWrapper}>
                <Post buttonTitle={t("registration.counselor.buttonTitle")}
                      title={t("registration.counselor.counselorTitle")}
                      buttonOnClickAction={onClickCreateButton} formClassName={style.postForm}>

                    {/*  상담관리자 정보  */}
                    <CounselorField title={''}/>
                </Post>
            </div>
        </>
    )
}